import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';

import "./NewMealReservation.css";

import history from "../../../../history";
import { getMeals } from "../../../../actions/mealActions";
import { getDailyMenu } from "../../../../actions/menuActions";
import { getUserMealReservation, newMealReservation, editMealReservation, deleteMealReservation } from "../../../../actions/mealReservationActions";

import Modal from "../../../CustomViews/Modal";

class NewMealReservation extends React.Component {
    constructor(props) {
        super(props);

        this.weekDays = [];
        this.initialState = {
            soup: { label: "< Wybierz zupę >", value: null },
            main: { label: "< Wybierz danie główne >", value: null },
            salad: { label: "< Wybierz sałatkę >", value: null },
            extra: { label: "< Wybierz dodatki >", value: null },
            errors: []
        };

        this.state = {
            currentDate: null,
            modal: false,
            ...this.initialState
        };
    }

    componentDidMount() {
        const now = new Date();
        const maxDate = new Date(`${now.toISOString().slice(0, 10)} 09:30:30`);
        if (now >= maxDate) now.setDate(now.getDate() + 1);
        let weekDay = (7 + now.getDay() - 1) % 7;
        if (weekDay > 4) now.setDate(now.getDate() + 7 - weekDay);
        weekDay = (7 + now.getDay() - 1) % 7;
        
        this.startDate = "";
        for (let i = 0; i < 5; i++) {
            const dayDiff = i - weekDay;
            const date = new Date(now);
            date.setDate(date.getDate() + dayDiff);
            this.weekDays.push({
                past: dayDiff < 0,
                date: date.toISOString().slice(0, 10)
            });
        }

        this.setState({ currentDate: now.toISOString().slice(0, 10) });
        this.props.getMeals();
    }

    componentDidUpdate() {
        if (this.state.currentDate !== this.startDate) {
            this.props.getDailyMenu(this.state.currentDate);
            this.props.getUserMealReservation(this.state.currentDate);
            this.startDate = this.state.currentDate;
        }
    }

    onWeekDayClick = weekDay => this.setState({ currentDate: this.weekDays[weekDay].date });

    onSubmit = () => {
        this.setState({ ...this.initialState });
        const formValues = { date: this.state.currentDate };
        if (this.state.soup.value) formValues["soup"] = this.state.soup.value;
        if (this.state.main.value) formValues["main"] = this.state.main.value;
        if (this.state.salad.value) formValues["salad"] = this.state.salad.value;
        if (this.state.extra.value) formValues["extra"] = this.state.extra.value;
        if (this.props.currentMealReservation.orderID) this.props.editMealReservation(this.props.currentMealReservation.orderID, formValues, this.onError);
        else this.props.newMealReservation(formValues, this.onError);
    };

    onDelete = () => {
        this.setState({ modal: false });
        this.props.deleteMealReservation(this.props.currentMealReservation.orderID)
    };

    onError = ({ data }) => {
        this.setState({ errors: data.error });
    };

    renderError = error => {
        return error ? (
            <div className="ui error message">
                {error.message.map((line, index) => <p key={index}>{line}</p>)}
            </div>
        ) : null;
    };

    renderModal = () => {
        if (this.state.modal) {
            return (
                <Modal
                    title="Usunięcie rezerwacji"
                    content={<p>Czy na pewno chcesz usunąć tę rezerwację?</p>}
                    actions={(
                        <React.Fragment>
                            <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                            <button onClick={this.onDelete} className="ui negative button">Usuń</button>
                        </React.Fragment>
                    )}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    renderMenu = () => Object.entries(this.props.dailyMenu.content).sort(([groupID1, mealGroup1], [groupID2, mealGroup2]) => {
        const sortDiff = mealGroup1.categorySort - mealGroup2.categorySort;
        if (sortDiff !== 0) return sortDiff;

        const a = Number(groupID1);
        const b = Number(groupID2);

        if (!Number.isNaN(a) && !Number.isNaN(b)) return a - b;
        if (!Number.isNaN(a)) return -1;
        if (!Number.isNaN(b)) return 1;

        return groupID1.localeCompare(groupID2);
    }).map(([groupID, mealGroup]) => {
        return (
            <React.Fragment key={groupID}>
                <div className="ui small header">
                    <div className="content">{mealGroup.mealDescription}:</div>
                </div>
                <ul>{mealGroup.rows.map(row => {
                    return (
                        <li key={row.posID}>{row.description}</li>
                    );
                })}</ul>
            </React.Fragment>
        );
    });

    renderReservation = () => {
        const weekDay = this.weekDays.find(weekDay => weekDay.date === this.state.currentDate);
        if (this.props.currentMealReservation.orderID) {
            return (
                <div className="ui grid">
                    <div className="row">
                        <div className="ten wide column">
                            <div className="content">
                                Zarezerwowane pozycje:
                                {["soup", "main", "salad", "extra"].map(key => (
                                    <React.Fragment key={key}>
                                        {this.props.currentMealReservation[key] ? (
                                            <React.Fragment>
                                                <br /><b>{this.props.currentMealReservation[key].description}</b>
                                            </React.Fragment>
                                        ) : null}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                        <div className="six wide column">
                            <div className="content">
                                Wartość zamówienia:<br />
                                <span className="big content">{this.props.currentMealReservation.foundedPrice} zł</span><br />
                                (przed dofinansowaniem <b>{this.props.currentMealReservation.totalPrice} zł</b>)
                            </div>
                        </div>
                    </div>
                </div>
            );

        } else if (weekDay && weekDay.past) {
            return (
                <div className="ui grid">
                    <div className="one column row">
                        <div className="column">
                            <div className="content">
                                Rezerwacja na ten dzień nie została złożona
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    };

    renderReservationForm = () => {
        const weekDay = this.weekDays.find(weekDay => weekDay.date === this.state.currentDate);
        if (weekDay && !weekDay.past) {
            return (
                <React.Fragment>
                    <div className="content">
                        Zupa:
                        <Select
                            value={this.state.soup}
                            onChange={value => this.setState({ soup: value })}
                            options={[{ label: "Bez zupy", value: null }, ...this.renderOptions("Z")]}
                            placeholder="Zupa"
                            noOptionsMessage={() => "Nie znaleziono zupy"}
                            maxMenuHeight="400px"
                        />
                    </div>
                    <div className="content">
                        Danie główne:
                        <Select
                            value={this.state.main}
                            onChange={value => this.setState({ main: value })}
                            options={[{ label: "Bez dania głównego", value: null }, ...this.renderOptions("DG")]}
                            placeholder="Danie główne"
                            noOptionsMessage={() => "Nie znaleziono dania głównego"}
                            maxMenuHeight="400px"
                        />
                    </div>
                    <div className="content">
                        Sałatka:
                        <Select
                            value={this.state.salad}
                            onChange={value => this.setState({ salad: value })}
                            options={[{ label: "Bez sałatki", value: null }, ...this.renderOptions("ST")]}
                            placeholder="Danie główne"
                            noOptionsMessage={() => "Nie znaleziono sałatki"}
                            maxMenuHeight="400px"
                        />
                    </div>
                    <div className="content">
                        Dodatkowe surówki/warzywa (extra płatne):
                        <Select
                            value={this.state.extra}
                            onChange={value => this.setState({ extra: value })}
                            options={[{ label: "Bez dodatków", value: null }, ...this.renderOptions("S")]}
                            placeholder="Dodatki"
                            noOptionsMessage={() => "Nie znaleziono dodatków"}
                            maxMenuHeight="400px"
                        />
                    </div>
                    {this.renderError(this.state.errors.filter(err => err.field === "content")[0])}
                    <button className="ui primary button" type="button" onClick={this.onSubmit}>{this.props.currentMealReservation.orderID ? "Zapisz zmiany" : "Złóż rezerwację"}</button>
                    {this.props.currentMealReservation.orderID ? (
                        <button className="ui negative button" type="button" onClick={() => this.setState({ modal: true })}>Usuń rezerwację</button>
                    ) : null}
                </React.Fragment>
            );
        }
    };

    renderOptions = category => {
        const options = [];
        this.props.meals.forEach(meal => {
            if (meal.category === category && this.props.dailyMenu.content[meal.mealID]) options.push(...this.props.dailyMenu.content[meal.mealID].rows.map(row => {
                return { label: row.description, value: row.posID };
            }));
        });
        return options;
    };

    render() {
        return (
            <React.Fragment>
                <div className="new-meal-reservation-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="active item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-reservations/my" className="active item">
                                <div className="content">Moje rezerwacje</div>
                            </Link>
                            <Link to="/meal-reservations" className="item">
                                <div className="content">Rezerwacje pracowników</div>
                            </Link>
                            <Link to="/menus/edit" className="item">
                                <div className="content">Edycja menu</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui five item menu">
                        {["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek"].map((weekDay, index) => {
                            const weekDayDate = this.weekDays.length > index ? this.weekDays[index].date : "";
                            return (
                                <div className={`${weekDayDate === this.state.currentDate ? "active " : ""}link item`} onClick={() => this.onWeekDayClick(index)} key={index}>
                                    <div className="content">{weekDay}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.dailyMenu.menuID && Object.entries(this.props.dailyMenu.content).length ? (
                            <React.Fragment>
                                <div className="ui large header">
                                    <div className="content">Menu na dzień {this.props.dailyMenu.date}:</div>
                                </div>
                                {this.renderMenu()}
                                <div className="ui divider" />
                                <div className="ui large header">
                                    <div className="content">Rezerwacja na dzień {this.props.dailyMenu.date}:</div>
                                </div>
                                {this.renderReservation()}
                                {this.renderReservationForm()}
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="utensils icon"></i>
                                        <div className="content">Menu na dzień {this.state.currentDate} nie zostało jeszcze wprowadzone</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    meals: state.meal.list,
    dailyMenu: state.menu.daily,
    currentMealReservation: state.mealReservation.current
});

export default connect(mapStateToProps, { getMeals, getDailyMenu, getUserMealReservation, newMealReservation, editMealReservation, deleteMealReservation })(NewMealReservation);